import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.css']
})
export class AlertModalComponent implements OnInit {
  modalData: { [key: string]: any } = {};
  userAction: string;
  closeButtonText: string;

  constructor(private bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    this.closeButtonText = this.modalData.closeButtonText != null ? this.modalData.closeButtonText : "Close";
  }

  cancelClicked() {
    this.userAction = "close";
    this.bsModalRef.hide();
  }

}